import React from "react";

function ChevronSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"

      viewBox="0 0 282 446"
    >
      <g fillRule="evenodd" stroke="none" strokeWidth="1">
        <g
          fillRule="nonzero"
          transform="rotate(90 140.548 140.851)"
        >
          <path d="M433.968 196.657L248.387 10.79C240.968 3.746 232.307.224 222.41.224c-10.088 0-18.652 3.521-25.697 10.566L10.848 196.657C3.615 203.887 0 212.549 0 222.637c0 10.28 3.619 18.843 10.848 25.693l21.411 21.413c6.854 7.23 15.42 10.852 25.697 10.852 10.278 0 18.842-3.621 25.697-10.852L222.41 131.271 361.168 269.74c6.848 7.228 15.413 10.852 25.7 10.852 10.082 0 18.747-3.624 25.975-10.852l21.409-21.412c7.043-7.043 10.567-15.608 10.567-25.693 0-10.09-3.614-18.751-10.851-25.978z"></path>
        </g>
      </g>
    </svg>
  );
}

export default ChevronSVG;
